import Swal from "sweetalert2";
import { fetchConToken } from "../../helpers/fetch";

// GET todos los contadores
export const getContadores = async () => {
    try {
        const resp = await fetchConToken('/api/dashboard/contadores', {}, 'GET');
        const body = await resp.json();

        if (resp.ok) {
            return body.contadores;
        } else {
            Swal.fire('Error', body.msg || 'Error al obtener contadores', 'error');
            return [];
        }
    } catch (error) {
        console.log('Error fetching contadores:', error);
        Swal.fire('Error', 'Error al conectar con el servidor', 'error');
        return [];
    }
};

// PUT editar contador
export const onEditarContador = (id, nombrerazonsocial, cedula, telefono, email, estado) => {
    return async (dispatch) => {
        try {
            const resp = await fetchConToken(
                `/api/dashboard/contadores/${id}`,
                { nombrerazonsocial, cedula, telefono, email, estado },
                'PUT'
            );
            const body = await resp.json();

            if (resp.ok) {
                Swal.fire({
                    icon: "success",
                    title: "Contador actualizado correctamente",
                    showConfirmButton: false,
                    timer: 2000
                });
                return body.contador;
            } else {
                Swal.fire('Error', body.msg || body.errors[0].msg, 'error');
                return null;
            }
        } catch (error) {
            console.log('Error editing contador:', error);
            Swal.fire('Error', 'Error al actualizar contador', 'error');
            return null;
        }
    }
};

// DELETE eliminar contador
export const serviceEliminarContador = (id) => {
    return async (dispatch) => {
        try {
            const resp = await fetchConToken(
                `/api/dashboard/contadores/${id}`,
                {},
                'DELETE'
            );
            const body = await resp.json();

            if (resp.ok) {
                Swal.fire({
                    icon: "success",
                    title: "Contador eliminado correctamente",
                    showConfirmButton: false,
                    timer: 2000
                });
                return { id };
            } else {
                Swal.fire('Error', body.msg || body.errors[0].msg, 'error');
                return null;
            }
        } catch (error) {
            console.log('Error deleting contador:', error);
            Swal.fire('Error', 'Error al eliminar contador', 'error');
            return null;
        }
    }
};
